import React from 'react';
import { Button, Typography, Box, Paper } from '@mui/material';

interface AnalysisConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const AnalysisConfirmDialog: React.FC<AnalysisConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 11500, // Lower than chat window but higher than other components
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          width: '100%',
          maxWidth: 'sm',
          p: 3,
        }}
      >
        {/* Title */}
        <Typography variant="h6" component="h2" gutterBottom>
          Confirm Analysis Report Generation
        </Typography>

        {/* Content */}
        <Typography variant="body1" gutterBottom sx={{ mb: 3 }}>
          This will generate a new analysis report. Due to processing requirements, you will not be
          able to generate another report for this estimate for 1 hour.
        </Typography>

        {/* Actions */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={onConfirm} color="primary" variant="contained">
            Proceed
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
